import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import SavedSearchActions from 'app/actions/SavedSearchActions';
import ModalActions from 'app/actions/ModalActions';
import SaveSearchButton from './SaveSearchButton';

export class SaveSearchButtonContainer extends React.PureComponent {
  render() {
    return <SaveSearchButton {...this.props} />;
  }
}

SaveSearchButtonContainer.propTypes = {
  savedSearch: ImmutablePropTypes.map,
  savedSearchActions: PropTypes.objectOf(PropTypes.func),
  modalActions: PropTypes.objectOf(PropTypes.func)
};

const mapStateToProps = state => ({
  savedSearch: state.getIn(['ui', 'savedSearch'])
});

const mapDispatchToProps = dispatch => ({
  savedSearchActions: bindActionCreators(SavedSearchActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SaveSearchButtonContainer);
